import { render, staticRenderFns } from "./UsuarioFuncionarioFiltros.vue?vue&type=template&id=08370b44"
import script from "./UsuarioFuncionarioFiltros.vue?vue&type=script&lang=js"
export * from "./UsuarioFuncionarioFiltros.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFuncionarioFiltros.vue?vue&type=style&index=0&id=08370b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports